import TextField from "@/common/elements/InputElements/TextField";
import { IntakeSectionHeader } from "@/common/styles";
import { Col, Row } from "antd";
import { FormContainer } from "../InmateDetails/styles";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import { getOptionsFromRefList } from "@/util/common_function";
import CommonDatePicker from "@/common/elements/DatePicker";
import { useSelector } from "react-redux";

const OffenseInformation = () => {
  const { bookingsFieldsEnabled } = useSelector(
    (state) => state?.bookings
  );
  const fullSearch = useSelector(state => state.fullSearch);
  return (
    <>
      <IntakeSectionHeader>
        <span>Offense Information</span>
      </IntakeSectionHeader>
      <FormContainer>
        <Row gutter={16}>
          <Col span={8}>
            <FormItem
              name="offenseDateTime"
              label="Offense Date & Time"
              layout="vertical"
            >
              <CommonDatePicker
                placeholder="MM/DD/YYYY HH:mm"
                format="MM/DD/YYYY HH:mm"
                disableFutureDates={true}
                disabled={!bookingsFieldsEnabled}
              />
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem
              name="offenseLocation"
              label="Offense Location"
              layout="vertical"
            >
              <TextField disabled={!bookingsFieldsEnabled} />
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem
              name="offenseCity"
              label="Offense City"
              layout="vertical"
              required={!fullSearch}
              rules={!fullSearch ? [
                {
                  required: true,
                  message: "Offense city is required",
                },
              ] : []}
            >
              <Select
                options={getOptionsFromRefList("Arrest_City")}
                placeholder="Offense City"
                showSearch
                variant="outlined"
                disabled={!bookingsFieldsEnabled}
              />
            </FormItem>
          </Col>
        </Row>
      </FormContainer>
    </>
  );
};

export default OffenseInformation;
